module.exports = __webpack_public_path__ + "img/dots_rdp_1.a34692cd.png";